// extracted by mini-css-extract-plugin
export var header = "_xk-1";
export var maskBottom = "_xk-6";
export var maskMiddle = "_xk-7";
export var maskTop = "_xk-5";
export var root = "_xk-0";
export var scrollDownButton = "_xk-3";
export var scrollDownButtonHidden = "_xk-4";
export var viewport = "_xk-2";